export default {
    ReportSaved: 0,
    ReportRendered: 1,
    ReportExported: 2
};